import { useState } from "react";

import Select from "react-select";
const MultiSelect = ({
  field,
  form,
  options,
  isMulti = false,
  placeholder = "Select",
  disabled
}) => {
  const [query, setQuery] = useState("");
  function onChange(option) {
    form.setFieldValue(
      field.name,
      option ? option.map((item) => item.value) : []
    );
  }


  const getValue = () => {
    if (options) {
      return isMulti && field.value
        ? options.filter((option) => {
          if(typeof field.value === "string" && field.name === "skills"){
            let checkField = field.value.trim();
            return checkField.includes(option.value);
          }else if(typeof field.value === "string"){
            // let checkField = field.value.trim().split(',');
            // if(checkField.length > 0){
            //   return checkField.includes(String(option.value))
            // }
            let checkField = field.value.trim().split(',').map(Number);
            return checkField.includes(option.value);
          }
          else{
            if(field?.value.length > 0){
              return field?.value.includes(option.value)
            }
          }
          return false;
        })
        : options.find((option) => option.value === field.value);
    } else {field
      return isMulti ? [] : "";
    }
  };

  if (!isMulti) {
    return (
      <Select
      options={options.filter(x => x.label.toLowerCase().includes(query.toLowerCase()))}
        name={field.name}
        value={
          options ? options?.find((option) => option.value === field.value) : ""
        }
        onChange={(option) => form.setFieldValue(field.name, option.value)}
        onBlur={field.onBlur}
        placeholder={placeholder}
        onInputChange={(value) => setQuery(value)}
        isDisabled={disabled}
        styles={{
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? "#CBD9EA" : "transparent",
            borderRadius:'0.3rem' ,
            color: "black"
        }),
        }}
      />
    );
  } else {
    return (
      <Select
        className={`react-select-container ${field.name === 'interviewerID' ? 'react-select-remove-icon' : ''}`}
        classNamePrefix="react-select"
        name={field.name}
        value={getValue()}
        onChange={onChange}
        onInputChange={(value) => setQuery(value)}
        options={options.filter(x => x.label.toLowerCase().includes(query.toLowerCase()))}
        isMulti={true}
        placeholder={placeholder}
        isDisabled={disabled}
        required
        styles={{
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? "#CBD9EA" : "transparent",
            borderRadius:'0.3rem' ,
            color: "black"
        }),
        menu: provided => ({ ...provided, width:"100%" ,right:'0px', borderRadius:'0.5rem' }),
        }}
      />
    );
  }
};

export default MultiSelect;
